import { FolderCopy } from "@mui/icons-material";
import { Box, Card, CardContent, Chip, CircularProgress, Stack, styled, Typography } from "@mui/material";
import { useEffect } from "react";
import { getAllModules } from "../../../core/services/admin.service";

// ---- Glassmorphism styled card (same recipe as the SelectableItemsModal cards) ----
const GlassCard = styled(Card)(({ theme }) => ({
  background: 'rgba(255, 255, 255, 0.15)',
  backdropFilter: 'blur(12px)',
  WebkitBackdropFilter: 'blur(12px)',
  border: '1px solid rgba(255, 255, 255, 0.25)',
  borderRadius: 16,
  boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.15)',
  transition: 'transform 0.2s ease, box-shadow 0.2s ease',
  cursor: 'pointer',
  '&:hover': {
    transform: 'translateY(-3px)',
    boxShadow: '0 12px 36px 0 rgba(31, 38, 135, 0.25)',
    background: 'rgba(255, 255, 255, 0.22)',
  },
}));

const statusMap = {
  1: { label: 'Active', color: 'success' },
  0: { label: 'Inactive', color: 'default' },
};

function ListModules({ modules, setModules }) {
  useEffect(() => {
    // already created items will be fetched through API call and set into list.
    getAllModules().then((modules) => {
      setModules((prev) => ({ ...prev, list: modules }));
    });
  }, []);

  const list = modules?.list;

  if (!list) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" py={6}>
        <CircularProgress size={28} />
      </Box>
    );
  }

  if (list.length === 0) {
    return (
      <Box textAlign="center" py={6}>
        <Typography variant="body2" color="text.secondary">
          No modules found.
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      display="grid"
      gridTemplateColumns="repeat(auto-fill, minmax(240px, 1fr))"
      gap={2}
      p={2}
    >
      {list.map((module) => {
        const status = statusMap[module.statusId] ?? {
          label: 'Unknown',
          color: 'default',
        };
        return (
          <GlassCard key={module.moduleOperationId} elevation={0}>
            <CardContent>
              <Stack direction="row" alignItems="center" spacing={1} mb={1}>
                <FolderCopy fontSize="small" color="primary" />
                <Typography variant="subtitle1" color="white" fontWeight={600} noWrap>
                  {module.moduleOperationName}
                </Typography>
              </Stack>
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
              >
                <Typography variant="caption" color="text.secondary">
                  ID: {module.moduleOperationId}
                </Typography>
                <Chip
                  size="small"
                  label={status.label}
                  color={status.color}
                  variant="outlined"
                />
              </Stack>
            </CardContent>
          </GlassCard>
        );
      })}
    </Box>
  );
}

export default ListModules